import React, { useEffect, useState } from "react";
import "./satisticCounter.css";
import AOS from "aos";
import "aos/dist/aos.css";
import CountUp, {useCountUp} from "react-countup";
import { getStatisticsCounters } from "../../axios";
import { Waypoint } from "react-waypoint";

import shoppingIcon from "../../assets/img/icon/cart-shopping-solid.svg"
import userIcon from "../../assets/img/icon/user-plus-solid.svg"
import blogsIcon from "../../assets/img/icon/newspaper-solid.svg"
import ProductsIcon from "../../assets/img/icon/book-medical-solid.svg"


const StatisticCounter = () => {
  const [StartCountUp , setStartCountUp] = useState(false) 

  const [currentItems, setCurrentItems] = useState([
    {
      title: "سفارشات شما",
      id:1,
      icon: shoppingIcon,
      number: "",
      animationDelay: 400,
    },
    {
      title: "محصولات ما",
      id:2,
      icon: ProductsIcon,
      number: "",
      animationDelay: 800,
    },
    {
      title: "همراهان آتروپین",
      id:3,
      icon: userIcon,
      number: "",
      animationDelay: 1200,
    },
    {
      title: "مطالب بلاگ",
      id:4,
      icon: blogsIcon,
      number: "",
      animationDelay: 1600,
    },
  ]);

  //getting data
  useEffect(() => {
    async function fetchData() {
      try {
        const { data } = await getStatisticsCounters();

        if (data) {
          const arrayNum = data?.split("-");

          setCurrentItems((prevItems) => 
            prevItems.map((item , index) => ({
                ...item,
                number : arrayNum[index]
            }))
          )
        }
      } catch (error) {
        console.log(error.message);
      }
    }

    fetchData();
  }, []);

  //initializing AOS animation effect
  useEffect(() => {
    AOS.init({
      startEvent: "load",
      once: true,
      offset: 100,
    });

    AOS.refresh();
  }, []);

  return (
    <Waypoint onEnter={() => setStartCountUp(true)}>
        <section id="facts" class="fun-facts">
          <div class="container">
            <div class="row">
              <div class="text-center col-12 section-title" data-aos="fade-zoom-in">
                <h3 className="main-title">
                خدمات و همراهان <span className="atropine-text">آتروپین</span> <span className="vertical-line"></span> با افتخار
                </h3>
                <div class="space-25"></div>
                <div class="space-50"></div>
              </div>
            </div>
            <div class="row align-items-center justify-content-center">
              {currentItems?.map(item => (
                <div class="col-lg-3 col-md-6 col-10">
                <div
                  class="fact-box text-center"
                  data-aos="fade-up"
                  data-aos-delay={item.animationDelay}
                >
                  <span class="lnr"><img src={item.icon} alt="icon" /></span>
                  <h5>
                    {StartCountUp ? <CountUp
                      start={0}
                      end={item.id === 3 && item.number !== 0 ? Number(item.number) : item.number}
                      duration={5}
                      separator=""
                    /> : (
                      item.id === 3 ? item.number * 3 : item.number)}
                  </h5>
                  <h6>{item.title}</h6>
                </div>
              </div>
              ))}
            </div>
          </div>
        </section>
    </Waypoint>
  );
};

export default StatisticCounter;
